// extracted by mini-css-extract-plugin
module.exports =  {"carbonTabsContainer":"carbonTabsContainer_cEC222jU"};